import { Component, HostBinding, effect, inject } from '@angular/core';
import { SocialUser } from "@abacritt/angularx-social-login";
import { Router } from '@angular/router';
import { OverlayService } from './shared/services/overlay.service';
import { PageService } from 'shared/services/page.service';
import { getRouterSelectors } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { MaintenanceStore } from 'core/stores/maintenance.store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'Freely Payments Acceptance Portal';

  user: SocialUser = new SocialUser;
  $loading = this.overlayService.$loading;

  private readonly maintenanceStore = inject(MaintenanceStore);
  private readonly router = inject(Router);

  @HostBinding('attr.class') get classes(): string {
    return this.pageService.$classes().join(' ');
  }

  constructor(
    protected overlayService: OverlayService,
    protected pageService: PageService,
    protected routerStore: Store,
  ){
    this.routerStore.select(getRouterSelectors().selectCurrentRoute).subscribe((routerState) => {
      this.pageService.setPageClass(routerState?.data?.pageClass)
    });

    // Reactive maintenance redirect. Runs on every flip of the store's
    // `isUnderMaintenance` signal — keeps the original route tree untouched
    // so existing auth redirects (dashboard → login) keep working.
    effect(() => {
      const down = this.maintenanceStore.isUnderMaintenance();
      const onMaintenance = this.router.url.startsWith('/maintenance');
      if (down && !onMaintenance) {
        this.router.navigateByUrl('/maintenance');
      } else if (!down && onMaintenance) {
        this.router.navigateByUrl('/');
      }
    });
  }

}

